export const testId = {
  pricingPageContractView: 'pricing-page-contract-view',
  pricingPageContractEdit: 'pricing-page-contract-edit',
  pricingPageContractCreate: 'pricing-page-contract-create',
  pricingLayoutPageHeader: 'pricing-layout-page-header',
  contractNotFound: 'contract-not-found',
  pricingContractForm: 'pricing-contract-form',
  fieldContractBreederId: 'field-contract-breeder-id',
  fieldContractBreederName: 'field-contract-breeder-name',
  fieldContractCondition: 'field-contract-condition',
  fieldContractConditionOption: 'field-contract-condition-option',
  fieldDateStartDate: 'field-date-startDate',
  fieldDateEndDate: 'field-date-endDate',
  fieldFileUploadInput: 'field-file-upload-input',
  fieldFileUploadButton: 'field-file-upload-button',
  fieldFileRemoveUploadButton: 'field-file-remove-upload-button',
  fieldFileUploadPreview: 'field-file-upload-preview',
  fieldFileUploadPreviewButton: 'field-file-upload-preview-button',
  fieldFileUploadPreviewPdf: 'field-file-upload-preview-pdf',
  fieldFileUploadPreviewImg: 'field-file-upload-preview-img',
  submitContract: 'submit-contract',
  contractCancelButton: 'contract-cancel-button',
  contractEditHeaderAction: 'contract-edit-header-action-button',
  addContractTerm: 'add-contract-term',
  editContractTerm: 'edit-contract-term',
  cancelContractTerm: 'cancel-contract-term',
  contractTermDrawer: 'contract-term-drawer',
  contractTermForm: 'contract-term-form',
  fieldContractTermTypes: 'field-contract-term-types',
  fieldContractTermTypeOption: 'field-contract-term-type-option',
  fieldBreeds: 'field-breeds',
  fieldBreedOption: 'field-breed-option',
  fieldPuppyColors: 'field-puppy-colors',
  fieldPuppyColorOption: 'field-puppy-color-option',
  fieldPuppyVarieties: 'field-puppy-varieties',
  fieldPuppyVarietyOption: 'field-puppy-variety-option',
  fieldQuantity: 'field-quantity',
  fieldInitialCost: 'field-initialCost',
  fieldInitialPrice: 'field-initialPrice',
  fieldMiddleCost: 'field-middleCost',
  fieldMiddlePrice: 'field-middlePrice',
  fieldFinalCost: 'field-finalCost',
  fieldFinalPrice: 'field-finalPrice',
  checkboxContractTermAddAndCreateNew: 'checkbox-contract-term-add-and-create-new',
  submitContractTerm: 'submit-contract-term',
  contractTermsTable: 'contract-terms-table',
  amendmentFileUploadInput: 'amendment-file-upload-input',
  fileAmendmentItem: 'file-amendment-item',
  fileAmendmentItemPreviewButton: 'file-amendment-item-preview-button',
  fileAmendmentItemUploaded: 'file-amendment-item-uploaded',
  fileAmendmentItemUploadedPreviewButton: 'file-amendment-item-uploaded-preview-button',
  deleteAmendmentFileUpload: 'delete-amendment-file-upload',
  contractListFilterTitle: 'contract-list-filter-title',
  contractListFilterTitleGoBack: 'contract-filter-title-go-back',
  contractListFilterTitleWithCategory: 'contract-list-filter-title-with-category',
  contractListFilterForm: 'contract-list-filter-form',
  filterFieldContractTermTypes: 'filter-field-contract-term-types',
  filterFieldContractTermTypeOption: 'filter-field-contract-term-type-option',
  filterFieldBreeds: 'filter-field-breeds',
  filterFieldBreedOption: 'filter-field-breed-option',
  filterFieldPuppyColors: 'filter-field-puppy-colors',
  filterFieldPuppyColorOption: 'filter-field-puppy-color-option',
  filterFieldPuppyVarieties: 'filter-field-puppy-varieties',
  filterFieldPuppyVarietyOption: 'filter-field-puppy-variety-option',
  contractListFilterFormSubmit: 'contract-list-filter-form-submit',
  contractListFilterFormClear: 'contract-list-filter-form-clear',
} as const;
